import styled from "styled-components";

export const BodyContainer = styled.div``;